export default __webpack_public_path__ + "static/media/search-icon.db6bfe49.svg";